<div class="search-results-page">
  <div class="search-header">
    <app-search [appearance]="'hero'" [placeholder]="'Search...'" [showButton]="false" class="results-search"></app-search>
  </div>

  <div class="results-container">
    <!-- Loading -->
    <div *ngIf="loading" class="state-message">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Searching...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="state-message error">
      <mat-icon color="warn">error_outline</mat-icon>
      <p>{{ error }}</p>
    </div>

    <!-- No query -->
    <div *ngIf="!query && !loading" class="state-message">
      <mat-icon>search</mat-icon>
      <p>Enter a search term above to get started.</p>
    </div>

    <!-- No results -->
    <div *ngIf="query && !loading && !error && totalCount === 0" class="state-message">
      <mat-icon>search_off</mat-icon>
      <p>No results found for <strong>"{{ query }}"</strong></p>
    </div>

    <!-- Results -->
    <div *ngIf="!loading && !error && totalCount > 0">
      <p class="results-summary">
        Found <strong>{{ totalCount }}</strong> result{{ totalCount !== 1 ? 's' : '' }} for <strong>"{{ query }}"</strong>
      </p>

      <div *ngFor="let group of resultGroups" class="result-group">
        <div class="group-header">
          <mat-icon class="group-icon">{{ group.icon }}</mat-icon>
          <h3 class="group-label">{{ group.label }}</h3>
          <span class="group-count">{{ group.items.length }}</span>
          <button mat-button color="primary" class="view-all-btn" (click)="viewAll(group.route)" type="button">
            View All
          </button>
        </div>

        <mat-divider></mat-divider>

        <div class="result-list">
          <div
            *ngFor="let item of group.items"
            class="result-item"
            (click)="navigateTo(group.route, item.id)"
          >
            <div class="result-item-content">
              <span class="result-title">{{ item.title }}</span>
              <span *ngIf="item.subtitle" class="result-subtitle">{{ item.subtitle }}</span>
            </div>
            <mat-chip *ngIf="item.status" class="status-chip" [class]="'status-' + (item.status | lowercase)">
              {{ item.status }}
            </mat-chip>
            <mat-icon class="result-arrow">chevron_right</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
